import { Component, Inject, ViewChild } from '@angular/core';
import { DialogeComponent } from '../dialoge/dialoge.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SharedService } from '../../Services/shared.service';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { Constant } from '../../Constants/constant';
import { BaseComponent } from '../base/base.component';
import { MatPaginator } from '@angular/material/paginator';
import { ValidationService } from '../../Services/validation.service';
import { PhoneNumberFormatPipe } from 'src/app/shared/Services/phone-number-format.pipe';
import moment from 'moment';
import { debounceTime, distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import { Subject, firstValueFrom } from 'rxjs';
import { LoggingService } from '../../Services/NGLogger/logging-service.service';
import { UserService } from 'src/app/user/Services/user.service';

@Component({
  selector: 'app-lookup-employee',
  templateUrl: './lookup-employee.component.html',
  styleUrls: ['./lookup-employee.component.css']
})
export class LookupEmployeeComponent extends BaseComponent {
  @ViewChild(MatPaginator, { static: false }) paginators!: MatPaginator;
  private buInputSubject = new Subject<string>();
  private ccInputSubject = new Subject<string>();
  EmployeeListData: any = [];
  CostlistArray: any = [];
  BussinessUnitArray: any = [];
  SearchValue: string = "";
  isSearch: boolean = false;
  TabIndex: number = 0;
  Operation: string = "Add Hiring Manager";
  IsBuLoading: boolean = false;
  IsBuEnter: boolean = false;
  filteredBu: any[] = [];
  BuListData: any = [];
  ValidBu: boolean = false;
  filteredCC: any[] = [];
  CCListData: any = [];
  ValidCC: boolean = false;
  maxDate: Date | undefined;
  IsCcLoading: boolean = false;
  IsCcEnter: boolean = false;
  noDataBu: boolean = false;
  noDataCc: boolean = false;
  override showloader: boolean = true;
  formGroup!: FormGroup;
  Submitted: any;
  constructor(
    public dialogRef: MatDialogRef<LookupEmployeeComponent>,
    private sharedService: SharedService,
    private Dilog: MatDialog,
    private validationService: ValidationService,
    private phoneNumberFormat: PhoneNumberFormatPipe,
    private loggingService: LoggingService,
    private userService: UserService,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) { super(); }
  override ngOnInit(): void {
    this.formInit();
    this.LoadBusinessListData();
    this.LoadCostCenterListData();
    this.Paginator.PageIndex = 0;
    this.Paginator.PageSize = this.DefaultPageSize;
    this.LoadListData();
    this.maxDate = moment().subtract(18, 'years').toDate();
    this.setupBusinessUnitSubscription();
    this.setupCostCenterSubscription();
  }

  formInit() {
    this.formGroup = this.fb.group({
      Id: [0],
      FirstName: ["", [Validators.required]],
      LastName: ["", [Validators.required]],
      CostCenterID: [null],
      BusinessUnitID: [null],
      DateOfBirth: [""],
      Gender: ["", [Validators.required]],
      Email: ["", [Validators.email]],
      PhoneNumber: [""],
      Address: [""],
      JobTitle: [""],
      EmploymentStartDate: [""],
      EmploymentEndDate: [""]
    });
  }


  formatDate(date: any) {
    if (date) {
      let newDate = Constant.formatDate(date);
      return this.sharedService.formatDate(newDate);
    }
    return null;
  }
  onPopupClose() {
    this.dialogRef.close('popClose');
  }
  changeTab(event: any) {
    if (event.index === 0) {
      this.formGroup.patchValue({
        FirstName: "",
        LastName: "",
        Address: "",
        BusinessUnitID: null,
        CostCenterID: null,
        DateOfBirth: "",
        Gender: "",
        Email: "",
        PhoneNumber: "",
        JobTitle: "",
        EmploymentStartDate: "",
        EmploymentEndDate: ""
      });

      this.Operation = "Add Hiring Manager";
      this.noDataCc = false;
      this.noDataBu = false;
      this.Submitted = false;
    }

    this.TabIndex = event.index;
  }

  gotoBack() {
    this.Operation = "Add Hiring Manager";
    this.TabIndex = 0;
  }
  clearSearchField() {
    this.SearchValue = "";
    this.LoadListData();
  }
  Select(data: any) {
    this.dialogRef.close(data);
  }
  clickMethod(item: any) {
    let jobid = item.jobId;
    const dialogRef = this.Dilog.open(DialogeComponent, {
      width: '30%',
      maxHeight: '90%',
      panelClass: 'modal-matdelete',
      data: { "title": "Warning!", "prefix":"Are you sure you want to delete ", "message":  item.firstName + " " + item.lastName + "?" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(data => {
      if (data.event == 'Yes') {
        this.Delete(item)
      }
    })
  }
  async Edit(data: any) {
    try {
      const res: any = await firstValueFrom(this.sharedService.GetEmployeeByID(data.id));
      if (res.succeeded) {
        this.formGroup.patchValue({
          Id: data.id,
          FirstName: res?.data.firstName,
          LastName: res?.data.lastName,
          Address: res?.data.address,
          DateOfBirth: res?.data.dateOfBirth,
          Gender: res?.data.gender,
          Email: res?.data.email,
          PhoneNumber: this.formatPhoneNumber(res?.data.phoneNumber),
          JobTitle: res?.data.jobTitle,
          EmploymentStartDate: res?.data.employmentStartDate,
          EmploymentEndDate: res?.data.employmentEndDate
        });

        if ((res?.data.businessUnitID ?? 0) > 0) {
          this.LoadBusinessListData();
        }
        if ((res?.data.costCenterID ?? 0) > 0) {
          this.LoadCostCenterListData();
        }

        const BuList = this.filteredBu.find((c: { id: number }) => c.id === res?.data?.businessUnitID);
        this.formGroup.patchValue({ BusinessUnitID: BuList ?? '' });

        const CcList = this.filteredCC.find((c: { id: number }) => c.id === res?.data?.costCenterID);
        this.formGroup.patchValue({ CostCenterID: CcList ?? '' });

        this.Operation = "Update Hiring Manager";
      }
    } catch (err) {
      this.loggingService.captureException(err);
    }

    this.TabIndex = 1;
  }

  async Delete(data: any) {
    try {
      const res: any = await firstValueFrom(this.sharedService.DeleteEmployee(data.id));

      if (res.succeeded) {
        this.showToastr(res.messages[0]);
        this.LoadListData();
      } else {
        const concatenatedMessage = res?.messages?.map((msg: any) => msg).join('\n');
        this.showToastr(concatenatedMessage, 'error');
      }
    } catch (err) {
      this.loggingService.captureException(err);
    }
  }

  async onSubmit() {
    this.Submitted = true;
    const submitValueBU = this.formGroup.value.BusinessUnitID;
    const submitValueCC = this.formGroup.value.CostCenterID;
    this.copyFormValues(this.formGroup, this.formGroup, [
      { sourceControlName: 'BusinessUnitID', targetControlName: 'BusinessUnitID', nestedKey: 'id' },
      { sourceControlName: 'CostCenterID', targetControlName: 'CostCenterID', nestedKey: 'id' },
    ]);
    if (this.formGroup.valid) {
      if (!this.noDataCc && !this.noDataBu) {
        try {
          const formData = this.formGroup.value;
          const res: any = await firstValueFrom(this.userService.RegisterUser(formData));

          if (res.succeeded) {
            this.showToastr(res.messages[0]);
            this.LoadListData();
            this.Submitted = false;
            this.TabIndex = 0;
          } else {
            this.formGroup.controls['BusinessUnitID'].setValue(submitValueBU);
            this.formGroup.controls['CostCenterID'].setValue(submitValueCC);
            const concatenatedMessage = res?.messages?.join('\n');
            this.showToastr(concatenatedMessage, 'error');
          }
        } catch (err) {
          this.loggingService.captureException(err);
        }
      }
    }
    else{
        this.formGroup.controls['BusinessUnitID'].setValue(submitValueBU);
        this.formGroup.controls['CostCenterID'].setValue(submitValueCC);
    }
  }

  async LoadCostCenterListData() {
    const searchData = this.SearchValue === "" ? "All" : this.SearchValue;
    const searchVm = {
      search: searchData,
      PageNumber: 0,
      PageSize: 0,
      EpId: null
    };

    try {
      const res: any = await firstValueFrom(this.sharedService.getCostCenterList(searchVm));

      if (res) {
        this.CCListData = res?.data?.items;
        this.filteredCC = res?.data?.items
          .filter((item: any) => item.name && item.name.trim() !== '')
          .map((item: any) => ({ id: item.id, name: `${item.name} : ${item.locationInfo}` }));

        if ((this.dialogData.BuId?.value ?? "") !== "") {
          this.formGroup.patchValue({ CostCenterID: this.dialogData.CcId?.value });
        }

        const Cc = this.filteredCC.find((x: any) => x.id === this.formGroup.get('CostCenterID')?.value);
        if (Cc) {
          this.formGroup.patchValue({ CC: Cc.name });
        }
      }
    } catch (err) {
      this.loggingService.captureException(err);
    }
  }

  async LoadBusinessListData() {
  const searchData = "";
  const searchVm = {
    search: searchData,
    PageNumber: 0,
    PageSize: 0,
    EpId: null
  };

  try {
    const res: any = await firstValueFrom(this.sharedService.getBusinessUnitList(searchVm));

    if (res) {
      this.BussinessUnitArray = res?.data?.items;
      this.filteredBu = res?.data?.items
        .filter((item: any) => item.name && item.name.trim() !== '')
        .map((item: any) => ({ id: item.id, name: `${item.name} : ${item.locationInfo}` }));

      if ((this.dialogData.BuId?.value ?? "") !== "") {
        this.formGroup.patchValue({ BusinessUnitID: this.dialogData.BuId.value });
      }

      const Bu = this.filteredBu.find((x: any) => x.id === this.formGroup.get('BusinessUnitID')?.value);
      if (Bu) {
        this.formGroup.patchValue({ BU: Bu.name });
      }
    }
  } catch (err) {
    this.loggingService.captureException(err);
  }
}


async LoadListData() {
  const searchData = this.SearchValue === "" ? "All" : this.SearchValue;
  let buId = this.dialogData?.BuId?.value || 0;
  let ccId = this.dialogData?.CcId?.value || 0;

  this.Paginator.Length = 0;

  const searchVm = {
    search: searchData,
    PageNumber: this.Paginator.PageIndex + 1,
    PageSize: this.Paginator.PageSize,
    BuId: buId,
    CcId: ccId
  };

  try {
    const res: any = await firstValueFrom(this.sharedService.getHiringList(searchVm));

    if (res) {
      this.EmployeeListData = res?.data?.items || [];
      this.Paginator.Length = this.EmployeeListData.length > 0 ? res?.data?.totalRecords : 0;

      if (this.isSearch && this.paginators) {
        this.paginators.pageIndex = 0;
      }

      this.isSearch = false;
      this.showloader = false;
    }
  } catch (err) {
    this.loggingService.captureException(err);
  }
}

setupBusinessUnitSubscription() {
  this.buInputSubject.pipe(
    debounceTime(300),
    distinctUntilChanged(),
    switchMap(async (userInput) => {
      const searchVm = {
        search: userInput,
        PageNumber: 0,
        PageSize: 0,
        EpId: this.dialogData?.EpId
      };

      try {
        const res: any = await firstValueFrom(this.sharedService.getBusinessUnitList(searchVm));
        return { res, userInput };
      } catch (err) {
        this.loggingService.captureException(err);
        return { res: null, userInput };
      }
    })
  ).subscribe(({ res, userInput }) => {
    this.IsBuLoading = false;

    if (res) {
      this.BuListData = res?.data?.items || [];
      this.filteredBu = this.BuListData
        .filter((item: any) => item.name && item.name.trim() !== '')
        .map((item: any) => ({ id: item.id, name: `${item.name} : ${item.locationInfo}` }));

      this.noDataBu = this.filteredBu.length === 0 && userInput.trim().length > 0;
    } else {
      this.filteredBu = [];
      this.noDataBu = true;
    }
  });
}

filterBu(e: any) {
  this.IsBuLoading = true;
  this.IsBuEnter =  true;
  const userInput = e.target.value.toLowerCase();
  this.buInputSubject.next(userInput);

  if (e.target.value === '') {
    this.formGroup.patchValue({ BusinessUnitID: null });
  }
}

onOptionSelectedBU(event: any) {
  const selectedOption = this.filteredBu.find(option => option.id === event.option.id);

  if (selectedOption) {
    this.formGroup.patchValue({ BusinessUnitID: selectedOption.id });
    this.ValidBu = false;
  }
}


setupCostCenterSubscription() {
  this.ccInputSubject.pipe(
    debounceTime(300),
    distinctUntilChanged(),
    switchMap(async (userInput) => {
      this.IsCcLoading = true;

      const searchVm = {
        search: userInput,
        PageNumber: 0,
        PageSize: 0,
        EpId: null
      };

      try {
        const res: any = await firstValueFrom(this.sharedService.getCostCenterList(searchVm));
        return { res, userInput };
      } catch (err) {
        this.loggingService.captureException(err);
        return { res: null, userInput };
      }
    })
  ).subscribe(({ res, userInput }) => {
    this.IsCcLoading = false;

    if (res) {
      this.CCListData = res?.data?.items || [];
      this.filteredCC = this.CCListData
        .filter((item: any) => item.name && item.name.trim() !== '')
        .map((item: any) => ({ id: item.id, name: item.name }));

      this.noDataCc = this.filteredCC.length === 0 && userInput.trim().length > 0;
    } else {
      this.filteredCC = [];
      this.noDataCc = true;
    }
  });
}

filterCC(e: any) {
  this.IsCcLoading = true;
  this.IsCcEnter = true;
  const userInput = e.target.value.toLowerCase();
  this.ccInputSubject.next(userInput);

  if (e.target.value === '') {
    this.formGroup.patchValue({ CostCenterID: null });
  }
}

onOptionSelectedCC(event: any) {
  const selectedOption = this.filteredCC.find(option => option.id === event.option.id);

  if (selectedOption) {
    this.formGroup.patchValue({ CostCenterID: selectedOption.id });
    this.ValidCC = false;
  }
}


  setPagination(e: any) {
    this.Paginator.PageSize = e.pageSize;
    this.Paginator.PageIndex = e.pageIndex;
    this.LoadListData();
  }

  onSearch() {
    this.isSearch = true;
    this.showloader = true;
    this.Paginator.PageIndex = 0;
    this.LoadListData();
  }

  omitSpecialChar(event: KeyboardEvent): void {
    const isValid = this.validationService.omitValidateSpecialChar(event);
    if (!isValid) {
      event.preventDefault();
    }
  }

  removeSpaces(e: any) {
    this.validationService.removeSpaces(e);
  }

  omitValidateSpecialChar(event: any) {
    const isValid = this.validationService.omitValidateSpecialChar(event);
    if (!isValid) {
      event.preventDefault();
    }
  }

  omitSpecialCharNumber(event: any) {
    this.validationService.omitSpecialCharNumber(event);
  }

  omitSpecialCharLastName(event: any) {
    if (!this.validationService.omitSpecialCharNumberLastName(event)) {
      event.preventDefault();
    }
  }


  onInputChange(event: Event) {
    const target = event.target as HTMLInputElement;
    if (target.value === '') {
      this.onSearch();
    }
  }
}
